import { ApiService, Authentication } from '../../common'
import { RMA, FormAdditionalFields } from '@one/types'
import { AxiosPromise } from 'axios'

export class AppRmaApi extends ApiService {
  createComplaint(form: RMA.App.Request.ComplaintFormDto): AxiosPromise<void> {
    this.invalidate(['rma-list', 'rma'])
    return this.put('/complaint', form, {
      authentication: Authentication.REQUIRED
    })
  }
  /**
   * @deprecated Use getComplaintForm instead
   */
  getComplaintReasons(): AxiosPromise<
    Array<RMA.App.Response.ComplaintReasonDto>
  > {
    return this.get('/complaint-reason', {
      authentication: Authentication.REQUIRED,
      cache: {
        ttl: 60 * 100,
        tags: ['rma']
      }
    })
  }

  getComplaints(
    pageNumber: number,
    pageSize: number
  ): AxiosPromise<RMA.App.Response.PagerComplaintDto> {
    return this.get('/complaints', {
      params: {
        pageNumber,
        pageSize
      },
      authentication: Authentication.REQUIRED,
      cache: {
        ttl: 60 * 100,
        tags: ['rma-list']
      }
    })
  }

  getComplaint(
    complaintId: string
  ): AxiosPromise<RMA.App.Response.ComplaintDto> {
    return this.get(`/complaint/${complaintId}`, {
      authentication: Authentication.REQUIRED,
      cache: {
        ttl: 60 * 100,
        tags: ['rma-single']
      }
    })
  }

  getComplaintForm(): AxiosPromise<RMA.App.Response.PreparedComplaintForm> {
    return this.get('/complaint-form', {
      authentication: Authentication.REQUIRED
    })
  }

  getAdditionalFieldsVisible(
    viewName: string
  ): AxiosPromise<FormAdditionalFields.AdditionalFields> {
    return this.get(
      `/configurations/additional-fields/visible?viewName=${viewName}`,
      {
        authentication: Authentication.REQUIRED
      }
    )
  }
}
